import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface IAcknowledgementResponse {
  sessionToken: string;
}

@Injectable({
  providedIn: 'root',
})
export class CertificationAcknowledgementService {
  private backendUrl: string = environment.backendUrl;
  
  // In-memory token storage (not localStorage)
  private sessionToken: string | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Submit acknowledgement and get session token
   */
  acknowledge(moduleAssignmentUuid: string): Observable<IAcknowledgementResponse> {
    return this.http.post<IAcknowledgementResponse>(
      `${this.backendUrl}/certification/acknowledge`, 
      { moduleAssignmentUuid }
    );
  }

  /**
   * Get stored session token
   */
  getSessionToken(): string | null {
    return this.sessionToken;
  }

  /**
   * Set session token (called after successful acknowledgement)
   */
  setSessionToken(token: string): void {
    this.sessionToken = token;
  }

  /**
   * Clear stored session token
   */
  clearSessionToken(): void {
    this.sessionToken = null;
  }

  /**
   * Check if acknowledgement is required
   * Acknowledgement is ALWAYS required for CERTIFICATION modules
   */
  isAcknowledgementRequired(practiceType: string): boolean {
    return practiceType === 'CERTIFICATION';
  }
}
